<template lang="">
  <div>
    <div class="fila hidden-sm-and-down">
      <el-row
        ><el-col class="bg-nosotros-2 bg-control" :md="12" style="background: #ececee"
          ><div class="col2 izquierda">
            <div class="header-spacer"></div>
            <h2 class="title-codigo">{{ $t('programa_integridad.titulo_etica') }}</h2>
            <div>
              <p class="texto-codigo" v-html="$t('programa_integridad.texto_etica')">
                <!-- {{ $t('programa_integridad.texto_etica') }} -->
              </p>
              <br />
              <a class="a-style" href="/newlog/documentos/codigo.pdf" target="_blank"> {{ $t('programa_integridad.descargar') }} </a>
            </div>
          </div></el-col
        >
        <el-col class="bg-nosotros-2" :md="12" style="background: white"
          ><div class="col2 derecha">
            <div class="header-spacer">
              <img src="@/assets/calidad/04_RESGUARDA.png" alt="resguarda" class="img-resguarda" />
            </div>
            <h2 class="title-codigo">{{ $t('programa_integridad.titulo_denuncia') }}</h2>
            <div>
              <p class="texto-codigo" v-html="$t('programa_integridad.texto_denuncia')">
                <!-- {{ $t('programa_integridad.texto_denuncia') }} -->
              </p>
              <p class="texto-dowload">{{ $t('programa_integridad.sub_texto_denuncia') }}</p>
            </div>
          </div></el-col
        ></el-row
      >
    </div>
    <div class="fila hidden-md-and-up">
      <el-row
        ><el-col class="bg-nosotros-2 bg-control" :md="12" style="background: #ececee"
          ><div class="col2 izquierda">
            <h2 class="title-codigo">{{ $t('programa_integridad.titulo_etica') }}</h2>
            <div>
              <p class="texto-codigo" v-html="$t('programa_integridad.texto_etica_mobile')">
                <!-- {{ $t('programa_integridad.texto_etica') }} -->
              </p>
              <br />
              <a class="a-style" href="/newlog/documentos/codigo.pdf" target="_blank"> {{ $t('programa_integridad.descargar') }}</a>
            </div>
          </div></el-col
        >
        <el-col class="bg-nosotros-2" :md="12" style="background: white"
          ><div class="col2 derecha">
            <div class="header-spacer">
              <img src="@/assets/calidad/04_RESGUARDA.png" alt="resguarda" class="img-resguarda" />
            </div>
            <h2 class="title-codigo">{{ $t('programa_integridad.titulo_denuncia') }}</h2>
            <div>
              <p class="texto-codigo" v-html="$t('programa_integridad.texto_denuncia_mobile')">
                <!-- {{ $t('programa_integridad.texto_denuncia') }} -->
              </p>
              <p class="texto-dowload">{{ $t('programa_integridad.sub_texto_denuncia') }}</p>
            </div>
          </div></el-col
        ></el-row
      >
    </div>
    <!-- <el-row class="full-height" :gutter="20"> -->
    <!-- <div class="hidden-sm-and-down">
        <el-col :span="12" class="etica-block">
          <div class="etica-css">
            <div class="title-codigo">
              <h2 class="title-codigo">{{ $t('programa_integridad.titulo_etica') }}</h2>
            </div>
            <div>
              <p class="texto-codigo">
                {{ $t('programa_integridad.texto_etica') }}
              </p>
              <a class="a-style" href="/newlog/documentos/codigo.pdf" target="_blank"> {{ $t('programa_integridad.descargar') }}</a>
            </div>
          </div>
        </el-col>

        <el-col :span="12" class="col col-right">
          <div class="col-inner">
            <img src="@/assets/calidad/04_RESGUARDA.png" style="width: 25%" alt="icono-footer" />

            <div style="margin-top: -40px">
              <h2 class="title-codigo">{{ $t('programa_integridad.titulo_denuncia') }}</h2>
            </div>
            <div>
              <p class="texto-codigo">
                {{ $t('programa_integridad.texto_denuncia') }}
              </p>

              <p class="texto-dowload">{{ $t('programa_integridad.sub_texto_denuncia') }}</p>
            </div>
          </div>
        </el-col>
      </div> -->
    <!-- <div class="hidden-md-and-up">
        <el-col :span="24" style="background: #f5f5f5 !important; margin: 0">
          <div class="etica-css">
            <div class="title-codigo">
              <h2 class="title-codigo">{{ $t('programa_integridad.titulo_etica') }}</h2>
            </div>
            <div>
              <p class="texto-codigo">
                {{ $t('programa_integridad.texto_etica') }}
              </p>
              <a class="a-style" href="/newlog/documentos/codigo.pdf" target="_blank"> {{ $t('programa_integridad.descargar') }}</a>
            </div>
          </div>
        </el-col>

        <el-col :span="24" class="col col-right">
          <div class="etica-css">
            <img src="@/assets/calidad/04_RESGUARDA.png" style="width: 30%; margin-bottom: -15px" alt="icono-footer" />

            <div style="margin-top: 20px">
              <h2 class="title-codigo">{{ $t('programa_integridad.titulo_denuncia') }}</h2>
            </div>
            <div>
              <p class="texto-codigo">
                {{ $t('programa_integridad.texto_denuncia') }}
              </p>

              <p class="texto-dowload">{{ $t('programa_integridad.sub_texto_denuncia') }}</p>
            </div>
          </div>
        </el-col>
      </div>
    </el-row> -->
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    download(url) {
      url = 'https://ns.suizoargentina.com/public/documentos/codigo.pdf'
      // url = 'https://ns.suizoargentina.com/public/newlog/documentos/codigo.pdf'
      // window.location.href = url
      window.open(url, '_blank')
    },
    async descargarPdf() {
      // let url = 'https://seguimiento.suizoargentina.com.ar/seguimiento/public/codigo.pdf'
      let url = '/newlog/documentos/codigo.pdf'
      // window.location.href = url
      window.open(url, '_blank')
    },
  },
}
</script>
<style>
.bg-control {
  height: 55vh;
}
.img-resguarda {
  width: 38%;
}
.fila {
  display: flex;
  align-items: flex-start;
}

.col2 {
  flex: 1;
  /* padding: 20px; */
  box-sizing: border-box;
}

/* 🔑 MISMO ALTO PARA AMBOS HEADERS */
.header-spacer {
  height: 50px; /* ajustá según la imagen */
  display: block;
  align-items: center; /* centra la imagen dentro */
}

.header-spacer img {
  max-height: 100%;
}
.derecha,
.izquierda {
  display: grid;
  grid-template-rows: auto 1fr;
  justify-content: center;
  align-items: center;
}
.derecha {
  display: grid;
  grid-template-rows: auto 1fr;
}
/* -- */
.full-height {
  height: 70vh !important;
  margin: 0;
  /* padding: 5% 10%; */
  /* padding: 10% 22% 10% 22%; */
}
.a-style,
.a-style:active {
  text-decoration: none;
  color: white;
  border: 1px solid #d35915;
  background-color: #d35915;
  padding: 10px 15% 10px 15%;
  font-family: 'MONTSERRAT-WHT';
}
/* Ajustes comunes a ambas columnas */
.col {
  padding: 0; /* el padding real está en .col-inner para control */
  display: flex;
  align-items: stretch;
}

/* Contenedor interno para manejar padding sin afectar el fondo */
.col-inner {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  min-height: 100%;
  padding: 10% 20% 10% 20%;
}

/* Estilos de color */
.col-left .etica-css {
  background: #f5f5f5; /* gris claro */
}

.col-right .col-inner {
  background: #ffffff; /* blanco */
}

/* Opcional: separación visual entre columnas si no usás gutter */
.el-row {
  --gutter: 20px;
}
.title-codigo {
  color: #d35915;
  margin-bottom: 3%;
  margin-top: 3%;
  /* font-family: 'roboto-black'; */
  font-family: 'roboto-cursiva-black';
}
.texto-codigo {
  margin-top: 0px;
  font-family: 'roboto-regular';
  text-align: left;
  /* hyphens: auto; */
  padding: 0% 0%;
  line-height: 1.5;
}
.etica-css {
  padding: 5% 10% 5% 20%;
  min-height: 100%;
}
.texto-dowload {
  color: #d35915;
  font-family: 'roboto-black';
  margin-top: 10px;
}
.etica-block {
  background: #f5f5f5 !important;
  height: 68vh !important;
  margin: 0;
}
@media (min-width: 2561px) {
  .title-codigo h2 {
    font-size: 50px;
  }
  .texto-codigo,
  .texto-dowload {
    font-size: 23px;
  }
  .etica-css {
    padding: 10% 20% 10% 20%;
  }
  .a-style {
    font-size: 27px;
  }
  .bg-control {
    height: 50vh;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .title-codigo {
    font-size: 50px;
  }
  .texto-codigo,
  .texto-dowload {
    font-size: 23px;
  }
  .etica-css {
    padding: 10% 20% 10% 20%;
  }
  .a-style {
    font-size: 25px;
  }
  .bg-control {
    height: 68vh;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .etica-block {
    height: 80vh !important;
  }
  .title-codigo {
    font-size: 45px;
  }
  .texto-codigo,
  .texto-dowload {
    font-size: 21px;
  }
  .etica-css,
  .col-inner {
    padding: 10% 10% 10% 20%;
  }
  .a-style {
    font-size: 24px;
  }
  .bg-control {
    height: 75vh;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .title-codigo {
    font-size: 40px;
  }
  .texto-codigo,
  .texto-dowload {
    font-size: 20px;
  }
  .a-style {
    font-size: 22px;
  }
  .etica-css,
  .col-inner {
    padding: 10% 21% 10% 21%;
  }
  .bg-control {
    height: 100vh;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .title-codigo {
    font-size: 40px;
  }
  .etica-block {
    height: 75vh !important;
  }
  .etica-css,
  .col-inner {
    padding: 10% 22% 10% 22%;
  }
  .texto-codigo,
  .texto-dowload {
    font-size: 18px;
  }
  .a-style {
    font-size: 18px;
  }
  .bg-control {
    height: 110vh;
  }
  .img-resguarda {
    width: 25%;
  }
}
@media (orientation: portrait) {
  @media screen and (min-width: 375px) and (max-width: 767px) {
    .titulo_principal_css {
      font-size: 40px;
    }
    .etica-css {
      padding: 12% 10% 12% 10%;
    }
    .texto-codigo,
    .texto-dowload {
      font-size: 19px;
      hyphens: auto;
    }
    .a-style {
      font-size: 15px;
    }
    .img-resguarda {
      width: 40%;
    }
    .title-codigo {
      font-size: 35px;
    }
    .bg-control {
      height: 55vh;
    }
  }
  @media (max-width: 375px) {
    .titulo_principal_css {
      font-size: 40px;
    }
    .etica-css {
      padding: 12% 10% 12% 10%;
    }
    .texto-codigo,
    .texto-dowload {
      font-size: 19px;
      hyphens: auto;
    }
    .a-style {
      font-size: 15px;
    }
    .img-resguarda {
      width: 40%;
    }
    .bg-control {
      height: 65vh;
    }
  }
}
@media (orientation: landscape) and (max-height: 500px) {
  .bg-control {
    height: 100vh !important;
  }
}
/* Responsive: en pantallas pequeñas las columnas se apilan */
/* @media (max-width: 768px) {
  .el-col {
    width: 100% !important;
    display: block;
  }
}

.title-codigo {
  color: #d35915;
  text-align: left;
  font-size: 1.5rem;
  font-family: 'roboto-cursiva-bold';
}
.texto-codigo {
  padding: 0px 50px 0px 0px;
  margin-top: -30px;

  text-align: left;
  font-size: 0.8rem;
  font-family: 'roboto-regular';
}
.etica-css {
  padding: 5% 20% 5% 20%;
}
@media (max-width: 1024px) and (max-height: 768px) {
  .title-codigo {
    text-align: left;
    font-size: 1.5rem;
  }
  .mision {
    margin: 0 auto;
    color: #fff;
    font-weight: 300;
    line-height: 1.5;
    font-size: 1.1rem;
    font-family: 'roboto-regular';
    padding: 0px 5%;
    text-align: justify;
  }
  .texto-codigo p {
    font-size: 1.1rem;
    text-align: left;
  }
  .etica-css {
    padding: 5% 10% 5% 10%;
  }
} */
</style>
